module.exports = __webpack_public_path__ + "static/img/lgwatersolution.4d54b94.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/project-detail/lgwatersolution.png
// module id = 27FL
// module chunks = 0